import { apiService } from '@/services/APIService';
import { rHandler } from '@/plugins/RHandler';
import { objectsRHandler, DEFAULT_PARAMS } from '@/utils/objectsRHandler';
import GiftedChild from '../list/gifted-children/index';

const API_PATH = 'ratings';

export const GiftedChildrenManager = {
  objects: {
    ...objectsRHandler(API_PATH, GiftedChild),
    index({ params, obs } = DEFAULT_PARAMS) {
      return rHandler(
        apiService.get(API_PATH, params),
        (response) => {
          const { data } =  response.data;
          return {
            response,
            ...Array.isArray(data) ? {
              items: data.map((i) => new GiftedChild(i, API_PATH)),
            } : {
              items: [],
              item: data, // { message }
            },
          };
        },
        (error) => ({ error }),
        obs,
      );
    },
    getUser({ args = [], params } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.get(`/${API_PATH}/user/${id}`, params),
        (response) => ({
          response,
          items: response.data.data || [],
        }),
        (error) => ({ error }),
      );
    },
    getUserEvents({ args = [], params } = DEFAULT_PARAMS) {
      const [id] = args;
      return rHandler(
        apiService.get(`/${API_PATH}/user/${id}/events`, params),
        (response) => ({
          response,
          items: response.data.data || [],
        }),
        (error) => ({ error }),
      );
    },
  },
};
